import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

const SnapshotContext = createContext(null);

export const SnapshotProvider = ({ onChange, children }) => {
  const locksRef = useRef(new Map());
  const [, force] = useState(0);

  const set = (name, loading) => {
    const prev = locksRef.current.get(name) || false;
    if (prev === loading) return;
    locksRef.current.set(name, !!loading);

    if (onChange) {
      const pendingNow = Array.from(locksRef.current.values()).filter(
        Boolean
      ).length;
      onChange(pendingNow);
    }
    force((x) => x + 1);
  };

  const pending = Array.from(locksRef.current.values()).filter(Boolean).length;
  const value = useMemo(() => ({ set, pending }), [pending]);

  return (
    <SnapshotContext.Provider value={value}>
      {children}
    </SnapshotContext.Provider>
  );
};

export const useSnapshot = () => {
  const ctx = useContext(SnapshotContext);
  if (!ctx) throw new Error('useSnapshot must be used inside SnapshotProvider');
  return ctx;
};

export const useSnapshotLock = (name, active) => {
  const { set } = useSnapshot();
  useEffect(() => {
    set(name, !!active);
    return () => set(name, false);
  }, [name, active, set]);
};
